// libs
import React, { useMemo, useEffect, useState } from 'react';
// components
import { Tab } from '../Tab';
import { PrimaryNav } from '../PrimaryNav';
import { AccountSwitcher } from '../AccountSwitcher';
import { AggregatedMetrics } from '@/pages/instamart/home/components/AggregatedMetrics';
import { CampaignList } from '@/components/CampaignList';
import { CreateCampaignButton } from '../CreateCampaignButton';
import { PerformanceSummary } from '@/pages/instamart/home/components/PerformanceSummary';
//widgets
import BudgetWarning from './widgets/BudgetWarning';
// icons
import { IconHome, IconSpeaker } from '@/constants/icons/svg';
// constants
import { ROLES } from '@local/typedefs/dist/common/userRoles';
import Routes from '@/constants/Routes';
// styles
import styles from './Layout.module.scss';
// stores
import useAccountStore from '@/stores/account';
import useDashboardStore from '@/stores/Dashboard';
const Layout = () => {
    const [nearExhaustionCampaigns, setNearExhaustionCampaigns] = useState([]);
    const [showWarning, setShowWarning] = useState(false);
    const permissions = useAccountStore((state) => state.loggedInAccountDetails.permissions);
    const haveCreateCampaignPermission = useMemo(() => {
        return permissions.includes(ROLES.CREATE_CAMPAIGN);
    }, [permissions]);
    const { activeCampaigns } = useDashboardStore();
    useEffect(() => {
        const filteredCampaigns = activeCampaigns.filter((camp) => camp.metrics.budgetBurnt &&
            parseFloat(camp.metrics.budgetBurnt) >= 0.8 * camp.budget);
        const tempNearExhaustionCampaigns = filteredCampaigns.map((camp) => ({
            id: camp.id,
            name: camp.name,
            budget: camp.budget,
            budgetBurnt: parseFloat(camp.metrics.budgetBurnt || '0'),
        }));
        if (tempNearExhaustionCampaigns.length > 0)
            setShowWarning(true);
        else
            setShowWarning(false);
        setNearExhaustionCampaigns([...tempNearExhaustionCampaigns]);
    }, [activeCampaigns]);
    return (React.createElement("div", { className: styles.container },
        React.createElement(PrimaryNav, null,
            React.createElement(AccountSwitcher, null),
            React.createElement(Tab, { Icon: IconHome, label: "Home", redirectUrl: Routes.INSTAMART_HOME }),
            React.createElement(Tab, { Icon: IconSpeaker, label: "All Campaigns", redirectUrl: Routes.INSTAMART.CAMPAIGN_LIST }),
            haveCreateCampaignPermission && React.createElement(CreateCampaignButton, null)),
        React.createElement("div", { className: styles.content },
            showWarning && (React.createElement(BudgetWarning, { nearExhaustionCampaigns: nearExhaustionCampaigns, onClose: () => setShowWarning(false) })),
            React.createElement(AggregatedMetrics, null),
            React.createElement(CampaignList, { campaigns: activeCampaigns }),
            React.createElement(PerformanceSummary, null))));
};
export default Layout;
